export const statusCache = new Map<number, boolean>();
export const clearBrandFollowCache = (): void => statusCache.clear();
